import LoginPage from 'views/Auth/LoginPage';
import ForgotPage from 'views/Auth/ForgotPage';
import SetPage from 'views/Auth/SetPage';
import LockScreenPage from 'views/Auth/LockScreenPage';
import PermissionExpiredPage from 'views/Auth/PermissionExpiredPage';

const authRoutes: types.routes.ISingleAuthRoute[] = [
	{
		path: '/login-page',
		component: LoginPage,
		layout: '/auth',
	},
	{
		path: '/forgot-page',
		component: ForgotPage,
		layout: '/auth',
	},
	{
		path: '/permission-expired',
		component: PermissionExpiredPage,
		layout: '/auth',
	},
	{
		path: '/lock-screen',
		name: 'lock.screen',
		component: LockScreenPage,
		layout: '/auth',
	},
	{
		path: '/set-page',
		component: SetPage,
		layout: '/auth',
	},
];

export default authRoutes;
